import { type FC } from "react";
import { Stack } from "@mui/material";
import { FilterProvider } from "@/partner/shared/components/Filter";
import { ReportsFilter } from "./ReportsFilter";
import { ReportsList } from "./ReportsList";

export const Reports: FC = () => (
  <FilterProvider>
    <Stack spacing={1}>
      <ReportsFilter />
      <ReportsList />
    </Stack>
  </FilterProvider>
);
